import request from '@/shared/api/request';

export const editKubernetesPool = (
  kubernetes_uuid: string,
  pool_id: string,
  data: {
    name: string;
    count: number;
  },
): Promise<unknown> =>
  request({
    url: `/kubernetes/${kubernetes_uuid}/node_pools/${pool_id}/`,
    method: 'PUT',
    data,
  });
